
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The preference for remuneration (including salary or hourly rate, benefits, etc.) for a position in a given country.`}</p>
    <p>{`Caution: this is currently under development and may be changed or removed without notice.`}</p>
    <p>{`This is only available for Apply with SEEK candidate profiles.
For candidate applications, uploaded candidate profiles & purchased profiles this will be an empty list.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;